let interval = null;
const subscribers = [];

const getStartTime = () => {
  const saved = localStorage.getItem("timerStartTime");
  return saved ? parseInt(saved, 10) : null;
};

const setStartTime = (timestamp) => {
  localStorage.setItem("timerStartTime", timestamp.toString());
};

const notify = (elapsedTime) => {
  subscribers.forEach((cb) => cb(elapsedTime));
};

const start = () => {
  if (interval) return;

  let startTime = getStartTime();
  if (!startTime) {
    startTime = Date.now();
    setStartTime(startTime);
  }

  interval = setInterval(() => {
    const elapsed = Math.floor((Date.now() - startTime) / 1000);
    notify(elapsed);
  }, 1000);
};

const reset = () => {
  clearInterval(interval);
  interval = null;
  localStorage.removeItem("timerStartTime");
  notify(0);
};

const subscribe = (callback) => {
  subscribers.push(callback);

  const startTime = getStartTime();
  const initialElapsed = startTime
    ? Math.floor((Date.now() - startTime) / 1000)
    : 0;

  callback(initialElapsed);

  return () => {
    const index = subscribers.indexOf(callback);
    if (index !== -1) {
      subscribers.splice(index, 1);
    }
  };
};

export const timerManager = {
  start,
  subscribe,
  reset,
};
